var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4544 2.8569C22.4998 2.74329 22.5109 2.61886 22.4862 2.49903C22.4615 2.3792 22.4023 2.26924 22.3157 2.18279C22.2291 2.09633 22.1191 2.03718 21.9992 2.01267C21.8794 1.98816 21.755 1.99937 21.6414 2.0449L3.4594 9.3189H3.4574L2.8924 9.5439C2.78561 9.58672 2.6927 9.6582 2.62393 9.75044C2.55515 9.84269 2.51318 9.95214 2.50263 10.0667C2.49208 10.1813 2.51337 10.2966 2.56415 10.3998C2.61492 10.5031 2.69322 10.5903 2.7904 10.6519L3.3024 10.9769L3.3044 10.9799L9.5474 14.9519L13.5204 21.1959L13.5234 21.1979L13.8484 21.7109C13.9102 21.8078 13.9976 21.8857 14.1008 21.9361C14.2041 21.9866 14.3192 22.0076 14.4337 21.9968C14.5481 21.9861 14.6573 21.944 14.7493 21.8752C14.8414 21.8064 14.9127 21.7136 14.9554 21.6069L22.4554 2.8569H22.4544ZM20.1634 5.2199L20.7514 3.7469L19.2794 4.3359L9.9114 13.7029L10.3344 13.9729C10.4121 14.0216 10.4777 14.0872 10.5264 14.1649L10.7964 14.5869L20.1634 5.2199Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.a5e00e38b23d062b10e3cad2554e4f94.svg";
export { ForwardRef as ReactComponent };